import {IconButton, Menu} from '@material-ui/core';
import {MoreVert} from '@material-ui/icons';
import React, {ReactNode} from 'react';
import MenuStateProvider from 'Shared/components/MenuStateProvider';

type ActionsMenuProps = {
  id?: string;
  children: ((onClose: () => void) => JSX.Element) | ReactNode;
};

const ActionsMenu = (props: ActionsMenuProps) => {
  return (
    <MenuStateProvider>
      {({anchor, close, open}) => (
        <>
          <IconButton id={props.id} className="menu" onClick={event => open(event.currentTarget)}>
            <MoreVert />
          </IconButton>
          <Menu
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            transformOrigin={{vertical: 'top', horizontal: 'center'}}
            getContentAnchorEl={null}
            onClose={close}
            open={Boolean(anchor)}
            anchorEl={anchor}
            onClick={close}
          >
            {typeof props.children === 'function' ? props.children(close) : props.children}
          </Menu>
        </>
      )}
    </MenuStateProvider>
  );
};

export default ActionsMenu;
